import { Pipe, PipeTransform,Injectable } from '@angular/core';

@Pipe({
  name: 'filterPlaneador'
})
@Injectable({
  providedIn: 'root'
})
export class FilterPlaneadorPipe implements PipeTransform {

  transform(arr: any[], filtro: string): any[] {
    if (!filtro) {
      return arr; // Si no se proporciona un filtro, devuelve el array sin cambios
    }
    // Convierte el filtro a minúsculas para realizar una búsqueda insensible a mayúsculas
    const filtroMin = filtro.toLowerCase();

    // Filtra el array y devuelve solo los objetos que contengan el filtro en cualquier valor
    return arr.filter(obj => {
      // Itera sobre todas las propiedades del objeto
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          // Convierte el valor de la propiedad a minúsculas para realizar una búsqueda insensible a mayúsculas
          const valor = obj[key]?.toString().toLowerCase();

          // Si el valor contiene el filtro, retorna true y el objeto se mantendrá en el resultado
          if (valor && valor.includes(filtroMin)) {
            return true;
          }
        }
      }
      return false; // Si no se encontró el filtro en ninguna propiedad, retorna false y el objeto se filtrará
    });
  }

/* transform(value: any[], arg: any): any{
    if(arg == '' || arg.length<2) return value;
    const resultadoData = [];
    for(const datos of value){
        if(datos.strArticulo.toLowerCase().indexOf(arg.toLowerCase())> -1 || datos.strDescripcion.toLowerCase().indexOf(arg.toLowerCase())> -1 ||
        datos.dblTotalF.toLowerCase().indexOf(arg.toLowerCase())> -1 || datos.dblTotalE.toLowerCase().indexOf(arg.toLowerCase())> -1){
            resultadoData.push(datos);
        }
    }
    return resultadoData;
} */
}
